import type { ContactSearchEntry } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

export const AVAILABLE_COMPANY_ANALYSIS_CONTACT_COLUMNS: ReadonlyArray<keyof ContactSearchEntry> = [
    "name",
    "privateData",
    "hasDirectPhoneNumbers",
    "title",
    "department",
    "numericCountryCode",
    "accuracyGrade",
    "isRevealed",
];
